import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Proprietaires from "@/pages/Proprietaires";
import Maisons from "@/pages/Maisons";
import Locataires from "@/pages/Locataires";
import Depenses from "@/pages/Depenses";
import Paiements from "@/pages/Paiements";
import Sejours from "@/pages/Sejours";
import Rapports from "@/pages/Rapports";
import Historique from "@/pages/Historique";
import Configuration from "@/pages/Configuration";
import Dev from "@/pages/Dev";
import DevUsers from "@/pages/DevUsers";
import DevPaiements from "@/pages/DevPaiements";
import DevEmails from "@/pages/DevEmails";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/legal" element={<Legal />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/proprietaires" element={<Proprietaires />} />
              <Route path="/maisons" element={<Maisons />} />
              <Route path="/locataires" element={<Locataires />} />
              <Route path="/depenses" element={<Depenses />} />
              <Route path="/paiements" element={<Paiements />} />
              <Route path="/sejours" element={<Sejours />} />
              <Route path="/rapports" element={<Rapports />} />
              <Route path="/historique" element={<Historique />} />
              <Route path="/configuration" element={<Configuration />} />
              <Route path="/dev" element={<ProtectedRoute devOnly><Dev /></ProtectedRoute>} />
              <Route path="/dev/users" element={<ProtectedRoute devOnly><DevUsers /></ProtectedRoute>} />
              <Route path="/dev/paiements" element={<ProtectedRoute devOnly><DevPaiements /></ProtectedRoute>} />
              <Route path="/dev/emails" element={<ProtectedRoute devOnly><DevEmails /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
